// Keep the fact (a, b) unchanged for mastery while varying how it is practised.
export function questionFor(gameId, question, index) {
  const { d1, d2, product, options } = question;
  const mode = gameId === "math-racer" && index % 2 === 1 ? "division"
    : gameId === "tower-builder" && index % 2 === 0 ? "missing"
    : gameId === "boss-arena" && index % 3 !== 0 ? "missing"
    : gameId === "monster-battle" && index % 3 === 2 ? "division"
    : "multiply";

  if (mode === "multiply") {
    return { label: "Find the product", expression: `${d1} × ${d2}`, answer: product, options };
  }

  // The API's distractors are products. For inverse questions, build factor
  // options locally so the correct choice and the recorded fact still agree.
  const factors = [d2];
  for (let offset = 1; factors.length < options.length; offset++) {
    const candidate = 2 + ((d2 - 2 + (offset % 2 ? offset : -offset) + 19 * 20) % 19);
    if (!factors.includes(candidate)) factors.push(candidate);
  }
  const shift = index % factors.length;
  const rotated = factors.slice(shift).concat(factors.slice(0, shift));
  return {
    label: mode === "division" ? "Solve the pit stop" : "Find the missing number",
    expression: mode === "division" ? `${product} ÷ ${d1} = ?` : `${d1} × ? = ${product}`,
    answer: d2,
    options: rotated,
  };
}
